import React from "react";

export const EmptyState = ({
                               title = "Подписчиков не найдено.",
                               hint = "Попробуйте изменить запрос поиска или обновить список.",
                           }: {
    title?: string;
    hint?: string;
}) => {
    return (
        <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-4">
            <div className="text-sm font-semibold text-slate-900">{title}</div>
            <div className="mt-1 text-sm text-slate-600">{hint}</div>
        </div>
    );
};
